/**
 * Multi-CNPJ cash-drawer PRE-SALE planner.
 * Outputs a quotation only; it never captures payment, decrements stock,
 * records a sale, prints fiscal documents or calls an RPC.
 */
const UUID=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const goodInt=(n,min,max)=>Number.isSafeInteger(n)&&n>=min&&n<=max;
export function prepareSharedPresale(cart,organizations){
 if(!Array.isArray(cart)||!Array.isArray(organizations)||!organizations.length||
  organizations.length>2||new Set(organizations).size!==organizations.length||
  organizations.some(o=>!UUID.test(o)))throw Error('invalid_organizations');
 if(!cart.length||cart.length>160)throw Error('invalid_cart');
 const seen=new Set();
 const sellers=organizations.map(organization_id=>{
  const scoped=cart.filter(item=>item.organization_id===organization_id);
  if(scoped.length>80)throw Error('invalid_seller_items');
  let subtotal_cents=0;
  const items=scoped.map(i=>{
   if(!UUID.test(i.id)||!goodInt(i.quantity,1,10000)||!goodInt(i.price_cents,1,1000000000)
    ||i.active!==true)throw Error('invalid_item');
   const key=organization_id+':'+i.id;
   if(seen.has(key))throw Error('duplicate_cart_item');
   seen.add(key);
   const line_total_cents=i.quantity*i.price_cents;
   if(!goodInt(line_total_cents,1,9000000000000))throw Error('amount_overflow');
   subtotal_cents+=line_total_cents;
   if(!goodInt(subtotal_cents,1,9000000000000))throw Error('amount_overflow');
   return {product_id:i.id,quantity:i.quantity,unit_price_cents:i.price_cents,line_total_cents};
  });
  return {organization_id,subtotal_cents,items};
 }).filter(s=>s.items.length);
 if(cart.length!==seen.size||!sellers.length)throw Error('cart_scope_mismatch');
 const total_cents=sellers.reduce((sum,s)=>sum+s.subtotal_cents,0);
 if(!goodInt(total_cents,1,9000000000000))throw Error('amount_overflow');
 return {sellers,total_cents};
}
const allowedMethods=['cash','card_terminal_1','card_terminal_2','external_pix'];
export function projectUnconfirmedTenders(snapshot,methods={}){
 if(!snapshot||!Array.isArray(snapshot.sellers))throw Error('invalid_snapshot');
 const breakdown=snapshot.sellers.map(s=>{
  const method=methods[s.organization_id]||'cash';
  if(!allowedMethods.includes(method))throw Error('invalid_payment_method');
  return {organization_id:s.organization_id,expected_cents:s.subtotal_cents,
   proposed_method:method,payment_confirmed:false};
 });
 return {breakdown,total_cents:snapshot.total_cents,mode:'simulation_only',
  captured_cents:0,settlement_created:false,refund_enabled:false};
}
